// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from './NoDataCell';
import { InfoTooltip } from '../tooltips';

// Utils
import { formatCurrency } from '../../../utils/i18n';
import Locale from '@/types/locale';
import Nullable from '@/types/nullable';
import DisclaimerInfos from '@/types/disclaimer-infos';
import NoDataText from '@/types/no-data-text';

type Props = {
  value: any;
  className?: string;
  disclaimer?: string;
  onClick?: () => void;
  id?: string;
  decimals?: number;
  withSuffixes?: boolean;
  locale?: Locale;
  hasDisclaimer?: boolean;
  valueDisclaimer?: Nullable<DisclaimerInfos>;
  noDataText?: NoDataText;
};

const CurrencyCell: React.FunctionComponent<Props> = ({
  value,
  className,
  disclaimer,
  onClick,
  id,
  decimals,
  withSuffixes,
  locale,
  valueDisclaimer,
  hasDisclaimer,
  noDataText,
}: Props) => {
  if (!value || value.value == null) {
    return <NoDataCell onClick={onClick} id={id} locale={locale} disclaimerKey={disclaimer} noDataText={noDataText} />;
  }

  return (
    <div className={classNames('cell currency-cell', className)} id={id ? `cell-${id}` : undefined} onClick={onClick}>
      <span className="markup-container">
        <span>{formatCurrency(value.value, decimals, value.currency, withSuffixes, locale)}</span>

        {hasDisclaimer && '*'}

        {valueDisclaimer && <InfoTooltip title={valueDisclaimer.title} message={valueDisclaimer.message} list={valueDisclaimer.list} />}
      </span>
    </div>
  );
};

export default CurrencyCell;
